import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import { type DentalStepParams, healthInsuranceTypeSchema } from './types'

export const healthInsuranceType = (params: DentalStepParams) => {
  const schema = healthInsuranceTypeSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_insurance_type.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_dental_de.shape.configuration_parameters.shape.health_insurance_type.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_dental:steps.dental_insurance_type.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('health_insurance_type'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('health_insurance_type'),
      valueToStepName: {
        mandatory: 'has_existing_dental_insurance',
        private: 'ineligible_status',
        none: 'ineligible_status',
      },
    },
    subFlow: SubFlow.Dental,
  } as const satisfies AnyStepConfiguration
}
